import { useCallback, useRef, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import searchColumns from './searchColumns'
import {Api} from '../../../helpers/Api'

const SearchUI = ({data, setData, name, filterBuilder}) =>{
    const search = searchColumns[name];
    const [load, setLoad] = useState();

    const renderLabel = (field) => {
        return <Form.Label className="search-label">{field.name} {field.required ? '*' : ''}</Form.Label>
    }

    const callApi = useCallback((field) =>{   
        return Api.call(`${field.url}`).then(response =>{
            field.options = response;
            setLoad(response);
        })   
    })

    const renderField = (field) => {
        let rendered = <></>;
        switch (field.type) {
            case 'time':
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Form.Control type="time" value={data[field.key]}
                        onChange={event => onChange(field.key, event.target.value)}
                        placeholder="" disabled={field.disabled} />
                </Form.Group></Col>
            break;
            case 'boolean':
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Form.Check rows={3} checked={data[field.key]}
                        onChange={event => onChange(field.key, event.target.checked)}
                        placeholder="" />
                </Form.Group></Col>
                break;
            case 'Apiselect':
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Form.Select className="popup-fields"
                        value={data[field.key] && typeof data[field.key] === "object" ? data[field.key].id : data[field.key]}
                        onChange={event => onChange(field.key, event.target.value)} 
                    >
                        <option value='' >Please Select</option>
                        {field.options && field.options?.map(o => {
                                return <option value={o.id} key={o.id}>{o.name}</option>
                        
                        })}
                    </Form.Select>
                </Form.Group>               
                </Col>
                break;

            case 'dateFromTo':
                rendered = <Row style={{paddingRight:0}}><Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    <Form.Label className="search-label">Start Date</Form.Label>
                    <Form.Control className="popup-fields" type="date" value={data[field.key[0]]}
                        onChange={event => FromtoDate(field.key[1], field.key[0], event.target.value)}
                        placeholder="" />
                    </Form.Group>                   
            </Col>
            
            <Col md={field.size} style={{paddingRight:0}}><Form.Group controlId={field.key} key={field.key}>
            <Form.Label className="search-label">End Date</Form.Label>
                <Form.Control className="popup-fields" type="date" value={data[field.key[1]]}
                    onChange={event => FromtoDate(field.key[0], field.key[1], event.target.value)}
                    placeholder="" />
            </Form.Group>                   
            </Col>
            </Row>
            break;

            case 'select':
                rendered = <Col md={field.size}><Form.Group className="form-group" controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Form.Select className="popup-fields"
                        value={data[field.key] && typeof data[field.key] === "object" ? data[field.key].id : data[field.key]}
                        onChange={event => onChange(field.key, event.target.value)} 
                     >
                        <option value='' >Please Select</option>
                        {field.options.map(o => {   
                            if(o.label){
                                return <option value={o.value} key={o.value}>{o.label}</option>
                            }  
                            else{   
                            return <option value={o} key={o}>{o}</option>
                            }
                        })}
                    </Form.Select>
                </Form.Group>               
                </Col>
                break;
            case 'date':
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Form.Control className="popup-fields" type="date" value={data[field.key]}
                        onChange={event => onChange(field.key, event.target.value)}
                        placeholder="" />
                </Form.Group>                   
                </Col>
                break;

            case 'fileUpload':
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <input type='file' className='form-control mb-1 popup-fields'
                        onChange={event => field.onchange(event, onChange)}
                        placeholder="Poster" />
                    {data['Poster'] && <img style={{ width: '100%', height: '350px', borderRadius:'5px' }} id={`img`}
                        src={data[field.key]} />}
                </Form.Group>                   
                </Col>
                break;
            case 'url':
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Form.Control type="url" className="popup-fields" value={data[field.key]}
                        onChange={event => field.onChange(data, event.target.value)}
                        placeholder="" />
                </Form.Group>                   
                </Col>
            default:
                rendered = <Col md={field.size}><Form.Group controlId={field.key} key={field.key}>
                     {renderLabel(field)}
                    <Form.Control type="text" className="popup-fields" value={data[field.key]}
                        onChange={event => onChange(field.key, event.target.value,true)}
                        placeholder="" />
                </Form.Group>                   
                </Col>
        }

        if (field.condition && data[field.condition.key] !== field.condition.value) {
            rendered = <Form.Control type="hidden" className="popup-fields" value={data[field.key]}
                onChange={event => onChange(field.key, event.target.value)}
                placeholder="" />
        }
        return rendered;
    }

    const FromtoDate = (relateKey, key, value) =>{
        let query;
        let related = relateKey;
        let d = {...data};
        d[key] = value;
        setData(d);
        if(d[relateKey] && d[relateKey] !== ""){
        if(key.includes("start")){
            query = `${related}_lte=${d[related]}&${key}_gte=${value}`
            filterBuilder(s=>{
                return { query }
            })
            return;
        }
            query = `${key}_lte=${value}&${related}_gte=${d[related]}`
            filterBuilder(s=>{
                return { query }
            })
        }
    }

    const onChange = (key, value, caseinsensitive = false) => {
        if(key !== "selector"){
            queryBuilder(key, value)
        }

        if(caseinsensitive){
             Caseinsensitive(key, value)
        }

        else{
            selector(key, value);
        }
    };

    const Caseinsensitive = (key, value) =>{
        let query;
        if(!value){
            query = ""
        }
        else
        {
           query = `${key}_contains=${value}`
        }
        let d = [];
        d["selector"] = data["selector"]
        d[key] = value;
        setData(d)
        filterBuilder(s=>{
            return { query }
        })
    };

    const selector = (key, value) =>{
        let d = {...data};
        d[key] = value; 
        setData(d)
    };

    const queryBuilder = (key, value) => {
        let query;
        if(!value){
            query = ""
        }
        else
        {
           query = `${key}=${value}`
        }
        let d = [];
        d["selector"] = data["selector"]
        d[key] = value;
        setData(d)
        filterBuilder(s=>{
            return { query }
        })
    };

    return(
     <div className='search'>
        <Row>
       {search.map((d)=>{
        if(d.type === 'Apiselect' && d.options.length === 0 ){
            callApi(d)  
        }
        return renderField(d) 
        })}   
        </Row> 
     </div>
    );
}

export default SearchUI;